import {useEffect, useState} from "react";
import {readModelFoundations, type ReadModelFoundation} from "../api/client";
import {useAuth} from "../auth/AuthContext";
import {AsyncState} from "../components/AsyncState";
import {PageHeader} from "../components/PageHeader";
import {StatusBadge} from "../components/StatusBadge";
import {CockpitConvergencePanel} from "../components/CockpitConvergencePanel";

export function DashboardFoundation() {
  const {authorizedFetch} = useAuth();
  const [model, setModel] = useState<ReadModelFoundation | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    void readModelFoundations(authorizedFetch, controller.signal)
      .then(setModel)
      .catch(problem => !controller.signal.aborted && setError(message(problem)));
    return () => controller.abort();
  }, [authorizedFetch]);
  return <>
    <PageHeader eyebrow="Software Factory / Dashboard" title="Operational foundations"
      description="Live, caller-scoped readiness for the single Inteacc Software Factory. Cockpit presentation capabilities converge here without duplicating control-plane authority." />
      <CockpitConvergencePanel />
    {error ? <AsyncState kind="error" detail={error} /> : !model
      ? <AsyncState kind="loading" detail="Reading governed source freshness without fixture fallback." />
      : <section className="read-model-grid" aria-label="Live read-model foundations">
        {model.areas.map(area => <article key={area.area} className="read-model-card">
          <header><h2>{area.area.replaceAll("_", " ")}</h2><StatusBadge value={area.state} /></header>
          {area.state === "UNAVAILABLE" ? <p>Unavailable: {area.unavailableReasonCode}</p>
            : <dl><div><dt>Authoritative records</dt><dd>{area.authoritativeCount}</dd></div>
              <div><dt>Demonstration records</dt><dd>{area.demonstrationCount}</dd></div></dl>}
          <small>{area.source} · {area.freshness.replaceAll("_", " ")} · {new Date(area.observedAt).toLocaleString()}</small>
        </article>)}
      </section>}
  </>;
}

function message(problem: unknown) {
  return problem instanceof Error ? problem.message : "Dashboard foundation could not be loaded";
}
